import React from 'react';
import { useIntl } from 'react-intl';

import Heading from '@bibliocommons/heading';

import AuthorLink from 'app/components/bibs/shared/AuthorLink';
import BibJacket from 'app/components/bibs/shared/BibJacket';
import { mapDisplayBibAuthorsToAuthorLinkAuthosProp } from 'app/helpers/displayBib';
import { displayBibShape } from 'app/shapes';

import './BibBrief.scss';

const BibBrief = ({ displayBib }) => {
  const intl = useIntl();

  const { authors, formatId, imageUrl, metadataId, publicationDate, subtitle, title } = displayBib;

  const displayFormat = intl.formatMessage({ id: `FORMAT.${formatId.toLowerCase()}` });
  const additonalInfo = [displayFormat, publicationDate].filter(Boolean).join(', ');

  return (
    <div className="cp-display-bib-brief">
      <BibJacket className="jacket" cover={imageUrl} format={formatId} metadataId={metadataId} title={title} />
      <div className="info">
        <Heading className="title" tagName="h3">
          {title}
        </Heading>
        <div>{subtitle}</div>
        <AuthorLink authors={mapDisplayBibAuthorsToAuthorLinkAuthosProp(authors)} renderAsLink={false} />
        {additonalInfo}
      </div>
    </div>
  );
};

BibBrief.propTypes = {
  displayBib: displayBibShape.isRequired
};

export default BibBrief;
